import storage from 'localforage'
import {
  createReduxStore as createReduxStoreBase,
  compose
} from '@vivaldis/common'
import { combineReducers, ReducersMapObject } from 'redux'
import { Saga } from 'redux-saga'
import { combineSessionSaga, createSessionReducer } from '@vivaldis/session'
import {
  combineAppSaga,
  createAppReducer,
  reduxPersistRehydrated
} from '@vivaldis/app'

export function createReduxStore(
  reducers: ReducersMapObject<any, any>,
  saga: Saga
) {
  return createReduxStoreBase({
    reducer: combineReducers(
      compose(createAppReducer, createSessionReducer(storage))(reducers)
    ),
    saga: compose(combineAppSaga, combineSessionSaga)(saga),
    debug: process.env.NODE_ENV !== 'production',
    middlewares: [],
    persistorCallback: store => {
      store.dispatch(reduxPersistRehydrated())
    }
  })
}
